import React, { useState } from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';
import moment from 'moment';

import Select from '../../../../../Form/Select';

import MailService from '../../../../../../services/MailService';
import DocumentService from '../../../../../../services/DocumentService';
import { useUiContext } from '../../../../../../context/UiContext';

const createStatementLabel = (statement) => {
  return `${statement?._invoice.sequence} - ${moment(
    statement?._invoice?.date
  ).format('M/D/YY')} - ${statement?._invoice?.status}`;
};

export default function Statements({ loanId }) {
  const [currentStatementId, setCurrentStatementId] = useState('');

  const { showToast } = useUiContext();

  const { data: statements } = useQuery({
    queryKey: ['statements', loanId],
    queryFn: () => DocumentService.getLoanStatements(loanId),
  });

  const options = statements?.map((statement) => ({
    value: statement?.id,
    label: createStatementLabel(statement),
  }));

  const { mutate: mailStatement, isPending } = useMutation({
    mutationFn: async () => {
      await MailService.sendMail({
        documentId: currentStatementId,
        recipient: 'borrower',
      });
    },
    onSuccess: () => {
      showToast({
        text: 'Statement delivered successfully',
        type: 'success',
      });
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  return (
    <div className="flex flex-col gap-10">
      <div className="grid gap-5 md:grid-cols-3 xl:grid-cols-4">
        <Select
          label="Statement"
          options={options}
          value={currentStatementId}
          setFieldValue={(_, value) => {
            setCurrentStatementId(value);
          }}
        />
      </div>
      <button
        disabled={isPending || !currentStatementId}
        type="button"
        className="btn w-full bg-indigo-500 md:max-w-sm text-white font-bold py-2 px-4 rounded hover:bg-indigo-600"
        onClick={mailStatement}
      >
        Mail Statement
      </button>
    </div>
  );
}
